export default "__VITE_ASSET__930eae63__"